import type { CSSProperties, ReactNode } from 'react';
import { createPortal } from 'react-dom';

import styles from './portal-layer.module.css';

type PortalLayerProps = {
  children: ReactNode;
  style?: CSSProperties;
};

export const PortalLayer = ({ children, style }: PortalLayerProps) =>
  createPortal(
    <div className="chakra-portal">
      <div className={styles.layer} style={style}>
        {children}
      </div>
    </div>,
    document.body
  );
